import { z } from 'zod';

export const SERVICE_CATEGORIES = [
  'baumpflege',
  'baumhausbau',
  'baumfaellung',
  'notfall',
  'sonstiges',
] as const;

export const contactFormSchema = z.object({
  name: z.string().min(2, 'Name muss mindestens 2 Zeichen haben'),
  email: z.string().email('Bitte gib eine gültige E-Mail-Adresse ein'),
  phone: z.string().min(5).max(30).optional(),
  category: z.enum(SERVICE_CATEGORIES),
  message: z.string().min(10, 'Nachricht muss mindestens 10 Zeichen haben').max(2000),
  consent: z.literal(true, {
    errorMap: () => ({ message: 'Bitte stimmen Sie der Datenschutzerklärung zu' }),
  }),
  honeypot: z.string().max(0).optional(),
});
